import { CircleAlert } from 'lucide-react'

import { errorMessage } from '@/api/client'
import { Button } from '@/components/ui/button'
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from '@/components/ui/empty'
import { LogoLoader } from '@/components/LogoLoader'

/** A page that is loading: the RowCall mark playing its opening once (LogoLoader), centred. */
export const FullPageSpinner = ({ label = 'Loading' }: { label?: string }) => (
  <div className="flex min-h-[50svh] items-center justify-center" role="status" aria-label={label}>
    <LogoLoader />
  </div>
)

/** A failed load, with a retry. */
export const ErrorState = ({ error, onRetry }: { error: unknown; onRetry?: () => void }) => (
  <Empty>
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <CircleAlert />
      </EmptyMedia>
      <EmptyTitle>This didn’t load</EmptyTitle>
      <EmptyDescription>{errorMessage(error)}</EmptyDescription>
    </EmptyHeader>
    {onRetry && (
      <Button variant="outline" onClick={onRetry}>
        Try again
      </Button>
    )}
  </Empty>
)
